import React, { Fragment, useState } from 'react';
import classnames from 'classnames';
import { generateKeyToComponent } from '../../../../utils/validators';
import { TooltipHover } from '../tooltip-hover/tooltip-hover';
import { Bar } from './bar';
import { Space } from '../space/space';
import { barsContainerPropTypes } from '../../model';

export const BarsContainer = ({
  barsContainerNamespace = '',
  barsHeight = null,
  padding = null,
  barsHoverInfo = null,
}) => {
  const [activeTooltip, setActiveTooltip] = useState(null);
  const hasHoverSupport = barsHoverInfo && barsHoverInfo.length === barsHeight.length;

  const barWidth = `calc(100% / ${barsHeight.length})`;
  return (
    <div
      className={`${barsContainerNamespace}__bars-container`}
      style={{ paddingLeft: padding, paddingRight: padding }}
    >
      {barsHeight &&
        barsHeight.map((barHeight, index) => (
          <Fragment key={generateKeyToComponent(barHeight)}>
            {hasHoverSupport ? (
              <TooltipHover
                className={`${barsContainerNamespace}__hover-tooltip`}
                hoverInfo={barsHoverInfo[index.valueOf()]}
                isVisible={index === activeTooltip}
                onOpen={() => setActiveTooltip(index)}
              >
                <Bar
                  className={classnames(`${barsContainerNamespace}__bar`, {
                    [`${barsContainerNamespace}__bar-hover`]: hasHoverSupport,
                  })}
                  height={barHeight}
                  width="24px"
                />
              </TooltipHover>
            ) : (
              <Bar className={`${barsContainerNamespace}__bar`} height={barHeight} width={barWidth} />
            )}
            {index !== barsHeight.length - 1 && <Space className={`${barsContainerNamespace}__space`} />}
          </Fragment>
        ))}
    </div>
  );
};

BarsContainer.propTypes = barsContainerPropTypes;
